module.exports = __webpack_public_path__ + "img/thumb_38.d3657c4d.jpg";